export default __webpack_public_path__ + "static/media/fot-layer.3d763d7b.svg";